'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'location-arrow';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f124';
var svgPathData = 'M240 240l0 16 0 208 20.9 0 144-388.9L16 219.1 16 240l208 0 16 0zM0 208L412.2 55.3 432 48l-7.3 19.8L272 480l-32 0-16 0 0-16 0-192 0-16-16 0L16 256 0 256l0-16 0-32z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faLocationArrow = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;